module.exports = __webpack_public_path__ + "img/1515034017.ed92f9c9.jpg";